import React from 'react';
import {
  Backdrop,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Typography,
  Grid
} from '@material-ui/core';

const LoadingCard = (props) => {
  return (
    <Grid
      container
      component={Backdrop}
      open={props.open}
      spacing={2}
      style={{ zIndex: 9999 }}
    >
      <Grid item xs={11} sm={6} md={4} xl={2} style={{ height: '29%' }}>
        <Card style={{ height: '100%' }}>
          <CardHeader>{props.title}</CardHeader>
          <CardContent className='card__content--align-center'>
            {props.loading && <CircularProgress />}
            <Typography style={{ marginTop: 8 }}>{props.message}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default LoadingCard;
